module.exports = __webpack_public_path__ + "static/media/flying.b708a755.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flying.svg
// module id = 231
// module chunks = 0